import { PressProps, useHover } from '@react-aria/interactions'
import { useButton } from '@react-aria/button'
import { PropsWithChildren, useRef } from 'react'
import Styles from 'blaze-components/WorkspaceDashboardSidebar/components/SectionHeader/SectionHeader.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ChevronRight } from 'almanac-ui/icons/12'
import cx from 'classnames'
import { mergeProps } from '@react-aria/utils'

export const Button = ({
  withChevron = true,
  children,
  ...props
}: PropsWithChildren<PressProps & { withChevron: boolean }>) => {
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps } = useButton(props, ref)
  const { isHovered, hoverProps } = useHover({})

  return (
    <button
      {...mergeProps(buttonProps, hoverProps)}
      ref={ref}
      className={cx(Styles.label, { [Styles.hovered]: isHovered })}
    >
      <Text variant="label">
        <span className={Styles.labelText}>{children}</span>
      </Text>
      {withChevron && <ChevronRight />}
    </button>
  )
}
